import * as Immutable from 'immutable';
import {createReducer} from 'redux-store';
import * as actionTypes from '../constants/course-evaluation-template-preview-action-types';

import type {List, Map} from 'immutable';

export type CourseEvaluationTemplatePreviewStore = {
    evaluationTemplate: Map<unknown, unknown>;
    questions: List<unknown>;
};

const sanitizeQuestions = (questions) => {
    questions = questions.map((question) => {
        return question.set(
            'questionCategories',
            question.get('questionCategories').map((qc) => {
                return qc.get('questionCategoryId');
            }),
        );
    });
    return questions;
};

const initialState = () => {
    return {
        evaluationTemplate: Immutable.Map(),
        questions: Immutable.List(),
    };
};

const actionsMap = {
    [actionTypes.GET_QUESTIONS_SUCCESS]: (state, action) => {
        return {
            questions: sanitizeQuestions(action.data),
        };
    },
    [actionTypes.DISPOSE]: () => {
        return initialState();
    },
};

export default createReducer<CourseEvaluationTemplatePreviewStore>(initialState(), actionsMap);
